export default "__VITE_ASSET__41864fd1__"